import React from 'react';
import classnames from 'classnames';

import './tagged-product-list.scss';
import { IProductDescription } from '../../../models/product/IProductDescription';
import { AdvancedProductCard } from '../advancedProductCard/AdvancedProductCard';
import { ManningOnlineStore } from '../../../../subscriptions/store/ManningOnlineStore';
import { AdvancedMenuButton } from '../readingList/advancedMenuButton/AdvancedMenuButton';

export interface IProps {

    children?: React.ReactNode;

    tag: string;

    showSlideArrows?: boolean;
    className?: string;

    store: ManningOnlineStore;

    showMoreInfoCardOnClick: boolean;
    pretitle?: string;
    subtitle?: string;

    onTitleClick?: () => void;
    onCloseClick?: () => void;

    onRemoveListClick?: () => void;

    onMoveUp?: () => void;
    onMoveDown?: () => void;

    isReordering?: boolean;

    advancedOperations?: {
        id: any;
        emailTitle: string;
        
        share: (id: any) => Promise<string>;
        onChangeTitle: () => void;
        onDelete: () => void;
        onReorder?: () => void;
    }
}

export interface IState {
    selectedProductDescriptionInfo: {
        productDescription: IProductDescription,
        x: number,
        y: number
    }; 
}
export class TaggedProductList extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    private root: HTMLElement;
    
    constructor(props: IProps){
        super(props);

        this.state = {
            selectedProductDescriptionInfo: null
        };

        this.handleRootRef = this.handleRootRef.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleLeftButtonClick = this.handleLeftButtonClick.bind(this);
        this.handleRightButtonClick = this.handleRightButtonClick.bind(this);
        this.handleProductSelection = this.handleProductSelection.bind(this);
        this.handleCloseAdvancedProductCardEvent = this.handleCloseAdvancedProductCardEvent.bind(this);
        this.handleAddToReadingListRequest = this.handleAddToReadingListRequest.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
    }

    public render(){
        const children = this.props.showMoreInfoCardOnClick ? React.Children.map(this.props.children, (child, index) => {
            if(React.isValidElement(child) && child.key != "dummy"){
                return React.cloneElement(child, {
                    onClick: this.handleProductSelection,
                 } as any)
            }
            
            return child;
        }) : this.props.children;

        return <div className={classnames("tagged-product-list-root", this.props.className)} ref={this.handleRootRef} 
                    onMouseLeave={this.handleCloseAdvancedProductCardEvent}>
                    <div className={classnames("tagged-product-list-tag")}>
                        {this.props.pretitle && <span className="tagged-product-list-pretitle">{this.props.pretitle}:&nbsp;</span>}
                        <span className={classnames("tagged-product-list-tag-label", {"clickable": this.props.onTitleClick != null })} dangerouslySetInnerHTML={{__html: this.props.tag}} onClick={this.props.onTitleClick}></span>
                        {this.renderAdvancedButtonIfNecessary()}
                        {this.renderReorderButtonsIfNecessary()}
                    </div>
                    { this.props.subtitle && 
                    <div className="tagged-product-list-subtitle" dangerouslySetInnerHTML={{__html: this.props.subtitle}}></div>}
                    
                    <div className="tagged-product-list-products-container-wrapper">
                        <div className="tagged-product-list-products-container" onScroll={this.handleScroll}>
                            { children }
                            { this.props.showMoreInfoCardOnClick && this.renderAdvancedCard() }
                        </div>

                        {this.props.showSlideArrows && 
                        <div className="tagged-product-list-left-arrow-container" onClick={this.handleLeftButtonClick}>
                            <button>
                                <svg width="18" height="28" viewBox="0 0 18 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.0435 0L17.3335 3.29L6.64683 14L17.3335 24.71L14.0435 28L0.0435009 14L14.0435 0Z" fill="black"/>
                                </svg>
                            </button>
                        </div>}

                        {this.props.showSlideArrows && 
                        <div className="tagged-product-list-right-arrow-container" onClick={this.handleRightButtonClick}>
                            <button>
                                <svg width="18" height="28" viewBox="0 0 18 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33332 0L0.0433254 3.29L10.73 14L0.0433254 24.71L3.33332 28L17.3333 14L3.33332 0Z" fill="black"/>
                                </svg>
                            </button>
                        </div>}
                    </div>
                    {this.props.onCloseClick && 
                    <button className="_close-button" onClick={this.props.onCloseClick}><i className="fa fa-times"></i></button>}
               </div>
    }

    private renderAdvancedCard(){
        const productDescriptionInfo = this.state.selectedProductDescriptionInfo;
        if(productDescriptionInfo == null) { return null; }

        return <AdvancedProductCard key={productDescriptionInfo.productDescription.manningId}
                                    productDescription={productDescriptionInfo.productDescription}
                                    coverPlaceholder={this.props.store.coverPlaceholder}
                                    wideCoverPlaceholder={this.props.store.wideCoverPlaceholder}
                                    onOutsideClick={this.handleCloseAdvancedProductCardEvent}
                                    onAddToReadingListRequest={this.handleAddToReadingListRequest}
                                    isInAtLeastOneReadingList={this.props.store.isInAtLeastOneReadingList(productDescriptionInfo.productDescription)}
                                    outsideClickIgnoredElementsSelector=".product-card-root, .product-card-root img"
                                    style={{
                                        top: productDescriptionInfo.y, 
                                        left: productDescriptionInfo.x
                                    }}/>
    }

    private renderAdvancedButtonIfNecessary(){
        if(this.props.advancedOperations == null) { return null; }
        
        return <AdvancedMenuButton id={this.props.advancedOperations.id}
                                   emailTitle={this.props.advancedOperations.emailTitle}
                                   share={() => this.props.advancedOperations.share(this.props.advancedOperations.id)}
                                   onChangeTitle={this.props.advancedOperations.onChangeTitle}
                                   onDelete={this.props.advancedOperations.onDelete}
                                   onReorder={this.props.advancedOperations.onReorder}/>
    }

    private renderReorderButtonsIfNecessary(){
        if(this.props.advancedOperations == null) { return null; }
        if(!this.props.isReordering) { return null; }

        return <div className='reorder-buttons-container'>
                    { this.props.onMoveUp != null ? <button title="move up" onClick={this.props.onMoveUp}><i className='fa fa-arrow-up'></i></button> : null }
                    { this.props.onMoveDown != null ? <button title="move down" onClick={this.props.onMoveDown}><i className='fa fa-arrow-down'></i></button> : null }
               </div>
    }

    private onRemoveClick(){
        if(this.props.onRemoveListClick != null){
            if(confirm(`Delete list: ${this.props.tag}?`)){
                this.props.onRemoveListClick();
            }
        }
    }

    private handleLeftButtonClick(){
        if(this.root == null) { return; }

        const container = this.root.querySelector(".tagged-product-list-products-container") as HTMLElement;
        if(container == null) { return; }

        container.scrollLeft -= 0.75*container.clientWidth;
    }

    private handleRightButtonClick(){
        if(this.root == null) { return; }

        const container = this.root.querySelector(".tagged-product-list-products-container") as HTMLElement;
        if(container == null) { return; }

        container.scrollLeft += 0.75*container.clientWidth;
    }

    private handleProductSelection(productDescription: IProductDescription){
        console.log("handle product selection");
        if(this.root == null) { return; }

        const htmlElement = this.root.querySelector(`[data-product-id='${productDescription.manningId}']`) as HTMLElement;
        if(htmlElement == null || htmlElement.matches(".dummy-product-card")) { return; }

        let scrollLeft = 0;

        const container = this.root.querySelector(".tagged-product-list-products-container") as HTMLElement;
        if(container != null && container.children.length > 1) { 
            scrollLeft = container.scrollLeft;
        }

        this.setState({
            selectedProductDescriptionInfo: {
                productDescription: productDescription,
                x: Math.max(htmlElement.offsetLeft + htmlElement.offsetWidth/2 - scrollLeft, 200),
                y: htmlElement.offsetTop + htmlElement.offsetWidth/2,
            }
        });
    }

    private handleScroll(e){
        this.updateArrowsState();
    }

    private handleRootRef(root: HTMLElement){
        this.root = root;

        if(this.root != null){
            setTimeout(() => {
                this.updateArrowsState();
            }, 40);
        }
    }

    public componentDidUpdate(){
        this.updateArrowsState();
    } 

    private updateArrowsState(){
        if(!this.root || !this.hasBeenMounted) { return; }

        const container = this.root.querySelector(".tagged-product-list-products-container") as HTMLElement;
        if(container == null || container.children.length <= 1) { return; }

        const firstChild = container.children[0] as HTMLElement;
        let lastChild = container.children[container.children.length - 1] as HTMLElement;
        if(lastChild.matches("span")){
            lastChild = lastChild.previousElementSibling as HTMLElement;
        }

        if(container.scrollLeft >= firstChild.offsetWidth) {
            if(!this.root.classList.contains("should-show-left-arrow")){
                this.root.classList.add("should-show-left-arrow");
            }
        }
        else {
            if(this.root.classList.contains("should-show-left-arrow")){
                this.root.classList.remove("should-show-left-arrow");
            }
        }

        if(container.scrollLeft + container.clientWidth < lastChild.offsetLeft + 0.1*lastChild.offsetWidth){
            if(!this.root.classList.contains("should-show-right-arrow")){
                this.root.classList.add("should-show-right-arrow");
            }
        }
        else {
            if(this.root.classList.contains("should-show-right-arrow")){
                this.root.classList.remove("should-show-right-arrow");
            }
        }
    }

    private handleCloseAdvancedProductCardEvent(){
        this.setState({
            selectedProductDescriptionInfo: null
        });
    }

    private handleAddToReadingListRequest(productDescription: IProductDescription){
        this.props.store.requestReadingListSpecificationForProduct(productDescription);
    }
}
